import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Paper,
  LinearProgress,
  Chip,
  Divider,
  Avatar,
} from '@mui/material';
import {
  Inventory,
  Devices,
  Build,
  BarChart,
  TrendingUp,
  Image as ImageIcon,
  Storage,
  Timeline,
  Schedule,
  ArrowForward,
  Public,
  Security,
  Calculate,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { systemAPI } from '../services/api';

const HomePage = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const statsResponse = await systemAPI.stats();
        setStats(statsResponse.data);
      } catch (error) {
        console.error('获取数据失败:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const featureCards = [
    {
      title: '物品浏览',
      description: '查看系统中的所有物品信息，包括物品名称和图片',
      icon: <Inventory color="primary" sx={{ fontSize: 40 }} />,
      color: 'primary.main',
      link: '/goods',
      linkText: '浏览物品',
    },
    {
      title: '设备查看',
      description: '了解生产过程中使用的各种设备和工具',
      icon: <Devices color="secondary" sx={{ fontSize: 40 }} />,
      color: 'secondary.main',
      link: '/equipments',
      linkText: '查看设备',
    },
    {
      title: '生产配方',
      description: '探索物品的生产配方和制造流程',
      icon: <Build color="warning" sx={{ fontSize: 40 }} />,
      color: 'warning.main',
      link: '/production-relations',
      linkText: '查看配方',
    },
    {
      title: '系统统计',
      description: '查看系统的整体数据和统计信息',
      icon: <BarChart color="success" sx={{ fontSize: 40 }} />,
      color: 'success.main',
      link: '#stats',
      linkText: '查看统计',
    },
  ];

  const quickLinks = [
    // {
    //   title: '热门物品',
    //   description: '查看最受欢迎的物品',
    //   icon: <TrendingUp />,
    //   link: '/goods',
    //   color: 'primary',
    // },
    // {
    //   title: '生产设备',
    //   description: '查看所有生产设备',
    //   icon: <Devices />,
    //   link: '/equipments',
    //   color: 'secondary',
    // },
    // {
    //   title: '快速配方',
    //   description: '查看最短生产时间的配方',
    //   icon: <Schedule />,
    //   link: '/production-relations',
    //   color: 'warning',
    // },
    {
    title: '基建量化工具',
    description: '直观呈现物品的生产链和原料需求',
    icon: <Calculate />,
    link: '/material-statistics',
    buttonText: '开始分析',
    color: 'warning',
  },
  {
    title: '基建蓝图库',
    description: '查看基建蓝图数据库',
    icon: <Storage />,
    link: '/blueprint',
    buttonText: '查看蓝图',
    color: 'info',
  },
  ];

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LinearProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* 英雄区域 */}
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Avatar
            src={`http://139.224.28.156:5000/images/endfield.png`}
            sx={{
              width: 120,
              height: 120,
              bgcolor: 'primary.main',
              boxShadow: 3,
            }}
          />
        </Box>
        <Typography variant="h2" fontWeight="bold" gutterBottom>
          基建量化辅助工具
        </Typography>
        <Typography variant="h5" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', mb: 3 }}>
          制作者：泡椒_泡椒
        </Typography>
        <Typography variant="h5" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', mb: 3 }}>
          b站：<a href="https://space.bilibili.com/7503663?spm_id_from=333.1007.0.0" target="_blank" rel="noopener noreferrer" style={{ color: '#29b6f6', fontStyle: 'italic', textDecoration: 'underline' }}>https://space.bilibili.com/7503663?spm_id_from=333.1007.0.0</a>
        </Typography>
        <Typography variant="h5" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', mb: 3 }}>
          抖音：<a href="https://v.douyin.com/W9K7j-23Wbw/ 1@9.com :7pm" target="_blank" rel="noopener noreferrer" style={{ color: '#29b6f6', fontStyle: 'italic', textDecoration: 'underline' }}>https://v.douyin.com/W9K7j-23Wbw/ 1@9.com :7pm</a>
        </Typography>
      </Box>

      {/* 统计卡片 */}
      {/* {stats && (
        <Grid container spacing={3} sx={{ mb: 6 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', transition: 'transform 0.3s', '&:hover': { transform: 'translateY(-4px)' } }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography color="text.secondary" variant="body2" gutterBottom>
                      物品总数
                    </Typography>
                    <Typography variant="h3" fontWeight="bold" color="primary.main">
                      {stats.goods_count || 0}
                    </Typography>
                  </Box>
                  <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'primary.lighter' }}>
                    <Inventory color="primary" sx={{ fontSize: 32 }} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', transition: 'transform 0.3s', '&:hover': { transform: 'translateY(-4px)' } }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography color="text.secondary" variant="body2" gutterBottom>
                      设备总数
                    </Typography>
                    <Typography variant="h3" fontWeight="bold" color="secondary.main">
                      {stats.equipments_count || 0}
                    </Typography>
                  </Box>
                  <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'secondary.lighter' }}>
                    <Devices color="secondary" sx={{ fontSize: 32 }} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', transition: 'transform 0.3s', '&:hover': { transform: 'translateY(-4px)' } }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography color="text.secondary" variant="body2" gutterBottom>
                      生产关系
                    </Typography>
                    <Typography variant="h3" fontWeight="bold" color="warning.main">
                      {stats.relations_count || 0}
                    </Typography>
                  </Box>
                  <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'warning.lighter' }}>
                    <Build color="warning" sx={{ fontSize: 32 }} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ height: '100%', transition: 'transform 0.3s', '&:hover': { transform: 'translateY(-4px)' } }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography color="text.secondary" variant="body2" gutterBottom>
                      总计项目
                    </Typography>
                    <Typography variant="h3" fontWeight="bold" color="success.main">
                      {stats.total_items || 0}
                    </Typography>
                  </Box>
                  <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'success.lighter' }}>
                    <Storage color="success" sx={{ fontSize: 32 }} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )} */}

      {/* 功能介绍 */}
      {/* <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ mb: 4 }}>
        主要功能
      </Typography>
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {featureCards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                transition: 'all 0.3s',
                '&:hover': { 
                  transform: 'translateY(-8px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      bgcolor: card.color + '20',
                      color: card.color,
                    }}
                  >
                    {card.icon}
                  </Box>
                </Box>
                <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
                  {card.title}
                </Typography>
                <Typography color="text.secondary" align="center">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                  component={Link}
                  to={card.link}
                  variant="contained"
                  endIcon={<ArrowForward />}
                  sx={{ 
                    bgcolor: card.color,
                    '&:hover': { bgcolor: card.color, opacity: 0.9 },
                  }}
                >
                  {card.linkText}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid> */}

      {/* 快速链接 */}
      <Paper elevation={2} sx={{ p: 4, borderRadius: 3, mb: 6 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
          <TrendingUp />
          快速链接
        </Typography>
        <Grid container spacing={3}>
          {quickLinks.map((link, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                component={Link}
                to={link.link}
                variant="outlined"
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 2,
                  borderColor: `${link.color}.main`,
                  borderWidth: 2,
                  transition: 'all 0.2s',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  '&:hover': {
                    transform: 'scale(1.02)',
                    borderWidth: 3,
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box
                      sx={{
                        p: 1,
                        mr: 2,
                        borderRadius: 2,
                        bgcolor: `${link.color}.lighter`,
                        color: `${link.color}.main`,
                      }}
                    >
                      {link.icon}
                    </Box>
                    <Typography variant="h6">{link.title}</Typography>
                  </Box>
                  <Typography color="text.secondary">
                    {link.description}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    variant="contained"
                    color={link.color}
                    sx={{ ml: 1, mb: 1, pointerEvents: 'none' }}
                  >
                    立即前往
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* 关于系统 */}
      {/* <Grid container spacing={4} sx={{ mb: 6 }}>
        <Grid item xs={12} md={6}>
          <Paper elevation={2} sx={{ p: 4, borderRadius: 3, height: '100%' }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
              <BarChart />
              系统介绍
            </Typography>
            <Typography variant="body1" paragraph>
              本系统是一个完整的生产管理平台，为用户提供物品、设备和生产关系的详细信息查看功能。
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                用户端特点：
              </Typography>
              <ul>
                <li><Typography variant="body1">只读访问：安全查看所有数据</Typography></li>
                <li><Typography variant="body1">实时数据：获取最新的生产信息</Typography></li>
                <li><Typography variant="body1">搜索过滤：快速找到所需信息</Typography></li>
                <li><Typography variant="body1">响应式设计：适配各种设备</Typography></li>
                <li><Typography variant="body1">直观界面：清晰的表格和卡片展示</Typography></li>
              </ul>
            </Box>
          </Paper>
        </Grid> */}
        
        {/* <Grid item xs={12} md={6}>
          <Paper elevation={2} sx={{ p: 4, borderRadius: 3, height: '100%' }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Timeline />
              数据流程
            </Typography>
            <Typography variant="body1" paragraph>
              系统中的数据通过清晰的生产流程组织：
            </Typography>
            <Box sx={{ mt: 2, p: 3, bgcolor: 'grey.50', borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Chip label="原料准备" color="info" />
                <ArrowForward color="action" />
                <Chip label="生产过程" color="warning" />
                <ArrowForward color="action" />
                <Chip label="设备使用" color="secondary" />
                <ArrowForward color="action" />
                <Chip label="物品产出" color="success" />
              </Box>
              <Divider sx={{ my: 2 }} />
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                每个生产关系都定义了完整的制造流程，包括原料、时间、设备和产出
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              通过浏览生产关系，您可以了解每个物品是如何制造的。
            </Typography>
          </Paper>
        </Grid>
      </Grid> */}

      {/* 系统状态 */}
      {/* <Paper elevation={2} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
          系统状态
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" paragraph>
              本系统采用现代化的前后端分离架构，为用户提供流畅的浏览体验。
            </Typography>
            <Typography variant="body1" paragraph>
              后端基于Flask + SQLAlchemy构建，提供稳定可靠的API服务；前端使用React + Material-UI，提供优秀的用户体验。
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                访问地址：
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Chip label="用户前端: http://139.224.28.156:3000" color="primary" />
                <Chip label="管理后台: http://139.224.28.156:4000" color="secondary" />
                <Chip label="后端API: http://139.224.28.156:5000" color="warning" />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ bgcolor: 'grey.50', p: 3, borderRadius: 2 }}>
              <Typography variant="h6" gutterBottom>
                技术支持
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Chip label="React" color="primary" sx={{ m: 0.5 }} />
                  <Chip label="Material-UI" color="primary" variant="outlined" sx={{ m: 0.5 }} />
                  <Chip label="React Router" color="primary" sx={{ m: 0.5 }} />
                  <Chip label="Axios" color="primary" variant="outlined" sx={{ m: 0.5 }} />
                </Grid>
                <Grid item xs={6}>
                  <Chip label="Flask" color="secondary" sx={{ m: 0.5 }} />
                  <Chip label="SQLAlchemy" color="secondary" variant="outlined" sx={{ m: 0.5 }} />
                  <Chip label="PostgreSQL" color="secondary" sx={{ m: 0.5 }} />
                  <Chip label="CORS" color="secondary" variant="outlined" sx={{ m: 0.5 }} />
                </Grid>
              </Grid>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                版本: 2.0.0 | 最后更新: 2024年
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper> */}
    </Container>
  );
};

export default HomePage;